<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar />
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav
          style="justify-content: flex-start"
          class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating"
        >
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar">
              <span class="navbar-toggler-icon"></span>
            </button>

            <button
              style="
                color: rgba(0, 0, 0, 0.5);
                border-color: rgba(0, 0, 0, 0.1);
              "
              class="btn btn-outline navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span style="padding-top: 0.5em"
                ><i class="fas fa-user-alt"></i><span class="account-div"></span
                ><i class="fas fa-angle-down"></i
              ></span>
            </button>
          </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-muted mb-0 hover-cursor">&nbsp;Insurance /&nbsp;</p>
            <p class="text-primary mb-0 hover-cursor">Batch Insurance</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ admin }}
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdown"
                >
                  <a class="dropdown-item link" @click="toPage('/password')">
                    <i class="fas fa-cog"></i
                    ><span class="right-dropdown">Change Password</span></a
                  >
                  <a class="dropdown-item link" @click="handleLogout"
                    ><i class="fas fa-sign-out-alt"></i
                    ><span class="right-dropdown">Logout</span></a
                  >
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <br />
                <br />
                <div class="row mb-2">
                  <div class="col-9">
                    <p
                      class="mb-0 pb-0 font-weight-bold"
                      style="font-size: 12px"
                    >
                      Batch No
                    </p>
                    <p
                      class="mt-0 pt-0 font-weight-bold"
                      style="font-size: 20px"
                    >
                      {{ detailData.label }}
                    </p>
                  </div>
                  <div class="col-3">
                    <p class="m-1 font-weight-bold">Status</p>
                    <div
                      class="text-capitalize"
                      v-if="
                        detailData.status &&
                        detailData.status.toLowerCase() === 'ongoing'
                      "
                    >
                      <div
                        class="badge font-weight-normal text-capitalize badge-pill"
                        style="
                          width: fit-content;
                          color: #3098f7;
                          background: #eaf5fe;
                          padding: 0.5rem;
                        "
                      >
                        {{ detailData.status }}
                      </div>
                    </div>
                    <div class="text-capitalize" v-else>
                      <div
                        class="badge font-weight-normal badge-pill"
                        style="
                          width: fit-content;
                          color: #00aa13;
                          background: rgba(0, 170, 19, 0.1);
                          padding: 0.5rem;
                        "
                      >
                        {{ detailData.status }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-9 font-weight-bold">
                    <div
                      class="shadow-sm rounded"
                      style="background: rgb(246, 247, 249); padding: 1rem 2rem"
                    >
                      <div
                        class="d-flex detail-patch-container align-items-end"
                        style="gap: 10px"
                      >
                        <div
                          class="app_input"
                          :style="{
                            width:
                              detailData.status &&
                              detailData.status.toLowerCase() === 'ongoing'
                                ? '45%'
                                : '50%',
                          }"
                        >
                          <div class="mb-1">Nama Vendor</div>
                          <multiselect
                            v-model="selectedVendor"
                            :options="vendorOptions"
                            label="partnerName"
                            :allow-empty="false"
                            :select-label="''"
                            :deselect-label="''"
                            placeholder="All"
                            track-by="id"
                            :multiple="false"
                            :close-on-select="true"
                            :disabled="
                              (detailData.status &&
                                detailData.status.toLowerCase() ===
                                  'declared') ||
                              (detailData.isIntegrated &&
                                detailData.readyToIntegrated)
                            "
                          ></multiselect>
                        </div>
                        <div
                          :style="{
                            width:
                              detailData.status &&
                              detailData.status.toLowerCase() === 'ongoing'
                                ? '45%'
                                : '50%',
                          }"
                        >
                          <div class="mb-1">Tanggal Deklarasi</div>
                          <input
                            v-model="declareDateInput"
                            :disabled="
                              detailData.status &&
                              detailData.status.toLowerCase() === 'declared'
                            "
                            type="date"
                            class="form-control"
                            name="search_start_rent_from"
                          />
                        </div>
                        <div
                          v-if="
                            detailData.status &&
                            detailData.status.toLowerCase() === 'ongoing'
                          "
                          style="width: 10%; margin-bottom: 2px"
                        >
                          <button
                            @click="confirmUpdateInfo"
                            class="btn btn-primary"
                            style="border-radius: 8px"
                          >
                            <div
                              class="d-flex align-items-center"
                              style="gap: 5px"
                            >
                              <div style="font-size: 14px">
                                <i class="fas fa-pencil-alt"></i>
                              </div>
                              <span>Ubah</span>
                            </div>
                          </button>
                        </div>
                      </div>
                      <div
                        class="mt-2"
                        style="font-weight: 400; font-size: 14px"
                      >
                        Masa polis utama sampai {{ detailData.polisEndDate }}
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <button
                      v-if="
                        detailData.status &&
                        detailData.status.toLowerCase() === 'ongoing' &&
                        detailData.isIntegrated &&
                        uploadedCompletingDataFile.length <= 0
                      "
                      class="btn btn-warning mb-2 w-100"
                      style="border-radius: 8px; background-color: #f78f30"
                      @click="handleCompletingData"
                    >
                      <div class="d-flex align-items-center" style="gap: 5px">
                        <img
                          width="16px"
                          src="@/assets/icon/file_warning_white.svg"
                          alt="icon_file_warning_white"
                        />
                        <span class="text-white">Lengkapi Data</span>
                      </div>
                    </button>
                    <button
                      v-if="
                        detailData.status &&
                        detailData.status.toLowerCase() === 'ongoing' &&
                        detailData.isIntegrated &&
                        uploadedCompletingDataFile.length > 0 &&
                        !detailData.readyToIntegrated
                      "
                      class="btn btn-primary mb-2 w-100"
                      style="border-radius: 8px"
                      @click="handleintegrateNow"
                    >
                      <div class="d-flex align-items-center" style="gap: 5px">
                        <img
                          width="16px"
                          src="@/assets/icon/gear_traced.svg"
                          alt="icon_file_warning_white"
                        />
                        <span class="text-white">Integrasikan Sekarang</span>
                      </div>
                    </button>
                    <button
                      v-if="
                        detailData.status &&
                        detailData.status.toLowerCase() === 'ongoing' &&
                        (!detailData.isIntegrated ||
                          detailData.readyToIntegrated)
                      "
                      class="btn btn-primary mb-2 w-100"
                      style="border-radius: 8px"
                      @click="handleFinishDeclaration"
                    >
                      <div class="d-flex align-items-center" style="gap: 5px">
                        <div style="font-size: 14px">
                          <i class="fas fa-check-circle"></i>
                        </div>
                        <span>Selesaikan Deklarasi</span>
                      </div>
                    </button>

                    <button
                      @click="confirmDeleteBatch()"
                      class="btn btn-danger w-100 mb-2"
                      style="border-radius: 8px"
                    >
                      <div class="d-flex align-items-center" style="gap: 5px">
                        <div style="font-size: 14px">
                          <i class="fas fa-exclamation-triangle"></i>
                        </div>
                        <span>Hapus Batch</span>
                      </div>
                    </button>
                    <button
                      v-if="
                        detailData.status &&
                        detailData.status.toLowerCase() === 'declared'
                      "
                      @click="confirmRoleback"
                      class="btn btn-warning mb-2 w-100 text-light"
                      style="border-radius: 8px"
                    >
                      <div class="d-flex align-items-center" style="gap: 5px">
                        <div style="font-size: 14px">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M9 11L5 15M5 15L9 19M5 15H16C17.0609 15 18.0783 14.5786 18.8284 13.8284C19.5786 13.0783 20 12.0609 20 11C20 9.93913 19.5786 8.92172 18.8284 8.17157C18.0783 7.42143 17.0609 7 16 7H15"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <span>Rollback ke Ongoing</span>
                      </div>
                    </button>
                    <button
                      v-if="
                        detailData.status &&
                        detailData.status.toLowerCase() === 'declared'
                      "
                      @click="downloadProvenFile"
                      class="btn btn-danger w-100"
                      style="
                        border-radius: 8px;
                        background-color: rgba(0, 174, 214, 1);
                        border-color: rgba(0, 174, 214, 1);
                      "
                    >
                      <div class="d-flex align-items-center" style="gap: 5px">
                        <div style="font-size: 14px">
                          <i class="fas fa-download"></i>
                        </div>
                        <span>Download Bukti Deklarasi</span>
                      </div>
                    </button>
                  </div>
                </div>
                <div
                  class="mt-5 mb-2 d-flex align-items-center justify-content-between"
                >
                  <span class="font-weight-bold">Details</span>
                  <button
                    @click="handleExport"
                    class="btn"
                    style="border: 1px solid #d1d9e2"
                  >
                    <div class="flex" style="gap: 10px">
                      <img src="~@/assets/icon/export.svg" />
                      <span>Export</span>
                    </div>
                  </button>
                </div>
                <table
                  class="table table-sm table-bordered table-striped table-responsive-sm"
                >
                  <thead class="">
                    <tr>
                      <th style="width: 20%">Order Details</th>
                      <th style="width: 25%">Product Details</th>
                      <th>Product Code</th>
                      <th>Year</th>
                      <th>Sum Insured</th>
                      <th>Vendor</th>
                      <th>Prorate</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable == true">
                      <td colspan="9" class="text-center">
                        <img src="~@/assets/images/load-button.gif" />
                      </td>
                    </tr>
                    <tr v-else-if="loadingTable == false && totalData == 0">
                      <td colspan="9" class="text-center">
                        Data not available
                      </td>
                    </tr>
                    <tr
                      v-for="(data, index) in detailData.items"
                      :key="index"
                      v-else
                    >
                      <td style="text-align: left">
                        <div>{{ data.orderGroupHash }}</div>
                        <div class="font-weight-bold">
                          {{ data.companyName }}
                        </div>
                        <div>Start: {{ dateFormat(data.startRent) }}</div>
                        <div>End: {{ dateFormat(data.endRent) }}</div>
                      </td>
                      <td style="text-align: left">
                        <div>
                          {{ data.model }} {{ " " }} {{ data.brand }} {{ " " }}
                          {{ data.specifications }}
                        </div>
                      </td>
                      <td>
                        {{ data.orderCode ? data.orderCode : "-" }}
                      </td>
                      <td>
                        {{ data.year ? data.year : "-" }}
                      </td>
                      <td>
                        {{ data.sumInsurance }}
                      </td>
                      <td>
                        {{ detailData.partnerName }}
                      </td>
                      <td>
                        {{ data.prorate }}
                      </td>
                      <td>
                        <button
                          class="btn btn-sm btn-action btn-action-trash"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Delete"
                          @click="confirmDeleteItem(data)"
                        >
                          <img src="~@/assets/icon/trash.svg" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div id="wrapperr">
                  <div id="c1" style="display: inline-flex">
                    <div style="margin-right: 10px">
                      <select
                        class="form-control form-control-sm"
                        v-model="itemPerPage"
                        @change="searchData()"
                      >
                        <option value="10">10</option>
                        <option value="40">40</option>
                        <option value="80">80</option>
                      </select>
                    </div>
                    <div class="alignLeft total-data">
                      Total Data {{ totalData }}
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a
                          class="is-active link"
                          @click="toDataPage(parseInt(currentPage) - 1)"
                          v-if="currentPage != 1"
                        >
                          <li>
                            {{ "<" }}
                          </li>
                        </a>
                        <a class="page">
                          <li>{{ currentPage }} of {{ totalPage }} page</li>
                        </a>
                        <a
                          class="is-active link"
                          @click="toDataPage(parseInt(currentPage) + 1)"
                          v-if="currentPage != totalPage"
                        >
                          <li>></li>
                        </a>
                      </ul>
                    </div>
                  </div>
                </div>
                ​
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <!-- startModal -->
      <div
        class="modal fade"
        id="modalDeleteBatchReason"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          style="width: 650px"
        >
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Delete Reason</h4>
              </div>
            </div>
            <div class="modal-body">
              <div class="container">
                <div class="mt-4">
                  <textarea
                    class="form-control"
                    :class="{
                      'form-control border-red': $v.deleteReason.$error,
                    }"
                    rows="3"
                    placeholder="Berikan penjelasan anda"
                    v-model.trim="$v.deleteReason.$model"
                  ></textarea>
                  <div style="float: right">
                    {{ deleteReason.length }}/{{ maxDeleteReasonLength }}
                  </div>
                  <div
                    style="color: red; font-size: 12px"
                    v-if="$v.deleteReason.$error && !$v.deleteReason.required"
                  >
                    Delete reason is required.
                  </div>
                  <div
                    style="color: red; font-size: 12px"
                    v-if="$v.deleteReason.$error && !$v.deleteReason.minLength"
                  >
                    Delete reason must have at least
                    {{ $v.deleteReason.$params.minLength.min }} letters.
                  </div>
                  <div
                    style="color: red; font-size: 12px"
                    v-if="$v.deleteReason.$error && !$v.deleteReason.maxLength"
                  >
                    Delete reason must have less than
                    {{ $v.deleteReason.$params.maxLength.max }} letters.
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-sm btn-danger"
                @click="closeDeleteBatchReasonModal"
              >
                Batal
              </button>
              <button class="btn btn-sm btn-primary" @click="validateReason">
                Simpan
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="modalFinishDeclare"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          style="width: 650px"
        >
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div
                class="change-title d-flex justify-content-between w-100 align-items-center"
              >
                <h5 class="modal-title">
                  Konfirmasi Deklarasi Selesai
                  <span class="text-danger">*</span>
                </h5>
                <span class="text-danger font-italic" style="font-size: 12px"
                  >Required</span
                >
              </div>
            </div>
            <div class="modal-body">
              <div class="container">
                <div class="mt-4">
                  <drag-and-drop-file
                    acceptedFiles=".csv,.xlsx,.pdf"
                    note="Format accepted are .csv, .pdf and .xlsx"
                    @change-file="handleChangeProvenFile"
                    :errorText="uploadFileError"
                    :shouldClearState="showModalFinishDeclare"
                    :inputId="'provenFile'"
                    :inputName="'provenFile'"
                    :allowReupload="true"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-sm btn-danger"
                @click="closeFinishDeclarationModal"
              >
                Batal
              </button>
              <button
                v-if="!loadingSubmitFinishDeclare"
                class="btn btn-sm btn-primary"
                @click="finishDeclare"
              >
                Selesai
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                disabled
                v-else
              >
                <img
                  src="~@/assets/images/2.gif"
                  style="height: 24px"
                />Menyimpan
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="modalCompletingData"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          style="width: 650px"
        >
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div
                class="change-title d-flex justify-content-between w-100 align-items-center"
              >
                <h5 class="modal-title">
                  Lengkapi Data
                  <span class="text-danger">*</span>
                </h5>
                <span class="text-danger font-italic" style="font-size: 12px"
                  >Required</span
                >
              </div>
            </div>
            <div class="modal-body">
              <div class="container">
                <div class="mt-4">
                  <drag-and-drop-file
                    acceptedFiles=".xlsx"
                    note="Format accepted is .xlsx, max 10MB"
                    :allowReupload="false"
                    @change-file="handleChangeCompletingData"
                    :errorText="uploadFileCompletingDataError"
                    :shouldClearState="showModalCompletingData"
                    :placeholder="'Click or drag a file for API Integration to this area to upload'"
                    :inputId="'completingDataFile'"
                    :inputName="'completingDataFile'"
                    :maxFiles="1"
                    :maxFileSize="10 * 1024 * 1024"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-sm btn-danger"
                @click="closeCompletingDataModal"
              >
                Batal
              </button>
              <button
                v-if="!loadingSubmitCompletingData"
                class="btn btn-sm btn-primary"
                @click="finishCompletingData"
              >
                Selesai
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                disabled
                v-else
              >
                <img
                  src="~@/assets/images/2.gif"
                  style="height: 24px"
                />Menyimpan
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import swal from "sweetalert";
import SideBar from "../SideBar";
import { Money } from "v-money";
import Swal from "sweetalert2";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import DragAndDropFile from "./CustomComponent/DragAndDropFile.vue";

export default {
  name: "insuranceBatchListPage",
  components: {
    SideBar,
    Multiselect,
    Money,
    DragAndDropFile,
  },
  data() {
    return {
      loadingTable: false,
      loadingSubmitFinishDeclare: false,
      source: "",
      admin: "",
      deleteReason: "",
      maxDeleteReasonLength: 144,
      permission: [],
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      itemPerPage: this.$route.query.itemPerPage
        ? this.$route.query.itemPerPage
        : 10,
      detailData: {},
      insuranceRate: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      selectInsurance: [],
      token: localStorage.getItem("jwt"),
      password: "",
      disableSave: false,
      cancelInsurancePermission: false,
      vendorOptions: [],
      selectedVendor: "",
      declareDateInput: "",
      uploadFileError: "",
      fileFinishDeclare: [],
      showModalFinishDeclare: false,
      // Completing Data
      loadingSubmitCompletingData: false,
      uploadFileCompletingDataError: "",
      fileCompletingData: [],
      showModalCompletingData: false,
      uploadedCompletingDataFile: [],
    };
  },
  validations: {
    deleteReason: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(144),
    },
  },
  methods: {
    downloadProvenFile(id) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      const payload = {
        batchId: Number(this.$route.params.id),
      };
      this.$http
        .post(process.env.BATCH_INSURANCE_LIST_DOCUMENTS, payload, {
          responseType: "blob",
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.status !== 200) {
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          } else {
            const data = response.data;
            const url = URL.createObjectURL(data);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Bukti-Deklarasi-${this.detailData.label}.zip`;
            a.target = "_blank";
            a.click();
            a.remove();
          }
        })
        .catch((error) => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    getDetailBatchInsurance(id) {
      this.loadingTable = true;
      const payload = {
        page: Number(this.$route.query.page),
        itemPerPage: Number(this.$route.query.itemPerPage),
      };
      this.$http
        .post(process.env.GET_LIST_BATCH_INSURANCE + `/${id}/detail`, payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          const { data, ...pagination } = response.data.data;
          this.currentPage = pagination.currentPage;
          this.totalData = pagination.totalData;
          this.totalPage = pagination.totalPage;
          this.detailData = data;
          this.declareDateInput = data.declaredDate.split(" ")[0];
          this.selectedVendor = {
            id: data.partnerDetailId,
            partnerName: data.partnerName,
          };
          this.loadingTable = false;
        })
        .catch((error) => {
          this.loadingTable = false;
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
      this.getActiveVendor();
    },
    confirmDeleteItem(data) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: `<strong style='font-size : 24px; font-weight : 600;'>Apakah kamu yakin mengeluarkan ${data.orderCode} ini ?</strong>`,
          icon: "warning",
          width: "32rem",
          html: `
            <div class="mt-3" style="max-width : 100%; font-size : 16px;">
            ${data.orderCode} akan kembali ke status pending declare
            </div>
          `,
          reverseButtons: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: `
            Ya, saya yakin!
          `,
          cancelButtonText: `
            Batalkan
          `,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteItem(data);
          } else {
          }
        });
    },
    deleteItem(data) {
      const batchId = Number(this.$route.params.id);
      this.loadingTable = true;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      const payload = {
        itemId: data.ItemId,
        batchId,
      };

      this.$http
        .post(process.env.DELETE_ITEM_BATCH_INSURANCE, payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          this.getDetailBatchInsurance(batchId);
          this.getAllCompletingDataFile();
          if (response.data.status === 200) {
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                text: `${data.orderCode} kembali ke status pending declare`,
                icon: "success",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          } else {
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          }
          this.loadingTable = false;
        })
        .catch((error) => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
          this.loadingTable = false;
        });
    },
    confirmDeleteBatch() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: `<strong style='font-size : 24px; font-weight : 600;'>Apakah kamu yakin ingin menghapus batch ini ?</strong>`,
          icon: "warning",
          width: "32rem",
          html: `
            <div class="mt-3" style="max-width : 100%; font-size : 16px;">
            Semua unit akan kembali ke status pending declare
            </div>
          `,
          reverseButtons: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: `
            Ya, saya yakin!
          `,
          cancelButtonText: `
            Batalkan
          `,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.openModal("DeleteBatchReason");
          } else {
          }
        });
    },
    bacthDelete(id) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      const payload = {
        batchId: Number(this.$route.params.id),
        action: "deleted",
        deletedReason: this.deleteReason,
      };
      this.$http
        .post(process.env.ROLEBACK_BATCH_INSURANCE, payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.status == 200 && response.data.status == 200) {
            this.closeDeleteBatchReasonModal(false);
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                text: `Batch berhasil dihapus`,
                icon: "success",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.$router.push({
                    path: "/insurance/batch",
                    query: {
                      batchOrder: "",
                      status: "",
                      startDateDeclare: "",
                      endDateDeclare: "",
                      partnerId: "",
                      page: 1,
                      itemPerPage: 10,
                    },
                  });
                }
              });
          } else {
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          }
        })
        .catch((error) => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    confirmRoleback() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: `<strong style='font-size : 24px; font-weight : 600;'>Apakah kamu yakin mengembalikan ke status ongoing?</strong>`,
          icon: "warning",
          width: "32rem",
          html: `
            <div class="mt-3" style="max-width : 100%; font-size : 16px; color: rgba(247, 143, 48, 1)">
            Peringatan: semua file yang telah di upload akan terhapus
            </div>
          `,
          reverseButtons: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: `
            Ya, saya yakin!
          `,
          cancelButtonText: `
            Batalkan
          `,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.roleback();
          } else {
          }
        });
    },
    roleback() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      const payload = {
        batchId: Number(this.$route.params.id),
        action: "rollback",
      };
      this.$http
        .post(process.env.ROLEBACK_BATCH_INSURANCE, payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.status == 200 && response.data.status == 200) {
            this.getDetailBatchInsurance(this.$route.params.id);
            this.getAllCompletingDataFile();
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                text: `Batch berhasil dikembalikan ke status ongoing`,
                icon: "success",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          } else {
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          }
        })
        .catch((error) => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    getActiveVendor() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      this.$http
        .post(
          process.env.GET_VENDOR_LIST,
          {
            keyword: "",
            page: 1,
            itemPerPage: 1000,
            status: "active",
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data.status == 200) {
            this.vendorOptions = response.data.data.data.filter(
              (item) => item.active == true
            );
          } else {
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          }
        })
        .catch(error => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    handleFinishDeclaration() {
      this.showModalFinishDeclare = true;
      this.openModal("FinishDeclare");
    },
    handleCompletingData() {
      this.showModalCompletingData = true;
      this.openModal("CompletingData");
    },
    handleChangeProvenFile(data) {
      if (data && data.length > 0) {
        this.uploadFileError = "";
      }
      this.fileFinishDeclare = data;
    },
    handleChangeCompletingData(data) {
      if (data && data.length > 0) {
        this.uploadFileCompletingDataError = "";
      }
      this.fileCompletingData = data;
    },
    async finishDeclare() {
      if (this.fileFinishDeclare.length <= 0) {
        this.uploadFileError = "File harus dipilih";
        return null;
      }
      this.loadingSubmitFinishDeclare = true;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      const mappedFile = await Promise.all(
        this.fileFinishDeclare.map(async (el) => {
          const base64File = await this.fileToBase64(el);
          return {
            fileName: el.name,
            fileBase64: base64File,
          };
        })
      );
      const payload = {
        batchId: Number(this.$route.params.id),
        documents: mappedFile,
      };
      this.$http
        .post(process.env.BATCH_DECLARE, payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          this.loadingSubmitFinishDeclare = false;
          if (response.status == 200 && response.data.status == 200) {
            this.getDetailBatchInsurance(this.$route.params.id);
            this.getAllCompletingDataFile();
            this.closeFinishDeclarationModal();
            this.fileFinishDeclare = [];
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                text: `Batch berhasil dideklarasikan`,
                icon: "success",
              })
              .then((result) => {});
          } else {
            this.loadingSubmitFinishDeclare = false;
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          }
        })
        .catch((error) => {
          this.loadingSubmitFinishDeclare = false;
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    async finishCompletingData() {
      if (this.fileCompletingData.length <= 0) {
        this.uploadFileCompletingDataError = "File harus dipilih";
        return null;
      }
      this.loadingSubmitCompletingData = true;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      const mappedFile = await Promise.all(
        this.fileCompletingData.map(async (el) => {
          const base64File = await this.fileToBase64(el);
          return {
            fileName: el.name,
            fileBase64: base64File,
          };
        })
      );
      const payload = {
        batchId: Number(this.$route.params.id),
        documents: mappedFile,
      };
      this.$http
        .post(process.env.BATCH_INTEGRATE_API + "/upload", payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          this.loadingSubmitCompletingData = false;
          if (response.status == 200 && response.data.status == 200) {
            this.getDetailBatchInsurance(this.$route.params.id);
            this.getAllCompletingDataFile();
            this.closeCompletingDataModal();
            this.fileCompletingData = [];
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                text: `Berhasil menyimpan data`,
                icon: "success",
              })
              .then((result) => {});
          } else {
            this.loadingSubmitCompletingData = false;
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          }
        })
        .catch((error) => {
          this.loadingSubmitCompletingData = false;
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    async handleintegrateNow() {
      this.loadingSubmitCompletingData = true;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      const confirmResult = await swalWithBootstrapButtons.fire({
        title: `<div>
          <strong style='font-size : 24px; font-weight : 600;'>Apakah kamu yakin akan integrasi ke ${this.detailData.partnerName}?</strong>
          <p style='font-size : 16px; color:#F06400; margin-top : 2rem'>Status unit tidak bisa dikembalikan ke Pending!</p>
          </div>`,
        icon: "warning",
        width: "32rem",
        reverseButtons: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: `
            Ya, saya yakin!
          `,
        cancelButtonText: `
            Batalkan
          `,
      });

      if (!confirmResult.isConfirmed) {
        this.loadingSubmitCompletingData = false;
        return;
      }
      const payload = {
        batchId: Number(this.$route.params.id),
      };
      this.$http
        .post(process.env.BATCH_INTEGRATE_API + "/approval", payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.status == 200 && response.data.status == 200) {
            this.getDetailBatchInsurance(this.$route.params.id);
            this.getAllCompletingDataFile();
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                text: `Vendor berhasil terintegrasi`,
                icon: "success",
              })
              .then((result) => {});
          } else {
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          }
        })
        .catch((error) => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    getAllCompletingDataFile() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      
      const payload = {
        batchId: Number(this.$route.params.id),
      };

      this.$http
        .post(process.env.BATCH_INTEGRATE_API, payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.status == 200 && response.data.status == 200) {
            this.uploadedCompletingDataFile = response.data.data
              ? response.data.data
              : [];
          } else {
            this.uploadedCompletingDataFile = [];
          }
        })
        .catch((error) => {
          this.uploadedCompletingDataFile = [];
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    closeFinishDeclarationModal() {
      this.showModalFinishDeclare = false;
      $("#modalFinishDeclare").modal("hide");
    },
    closeCompletingDataModal() {
      this.showModalCompletingData = false;
      $("#modalCompletingData").modal("hide");
    },
    validateReason() {
      this.$v.$touch();
      if (this.$v.$invalid || this.$v.deleteReason.$error) {
      } else {
        this.bacthDelete();
      }
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = function (e) {
          resolve(e.target.result.split("base64,")[1]);
        };

        reader.onerror = function (e) {
          reject(e);
        };

        reader.readAsDataURL(file);
      });
    },
    confirmUpdateInfo() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: `<strong style='font-size : 24px; font-weight : 600;'>Apakah kamu yakin akan mengubah info batch ini?</strong>`,
          icon: "warning",
          width: "32rem",
          reverseButtons: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: `
            Ya, saya yakin!
          `,
          cancelButtonText: `
            Batalkan
          `,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.updateInfo();
          } else {
          }
        });
    },
    updateInfo() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      const payload = {
        batchId: Number(this.$route.params.id),
        newPartnerId: Number(this.selectedVendor.id),
        declaredAt: this.declareDateInput,
      };

      this.$http
        .post(process.env.UPDATE_BATCH_INSURANCE_INFO, payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.status == 200 && response.data.status == 200) {
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                text: `Info batch telah berhasil diubah`,
                icon: "success",
              })
              .then((result) => {});
          } else {
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          }
        })
        .catch((error) => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    closeDeleteBatchReasonModal(shoulReset = true) {
      this.deleteReason = "";
      $("#modalDeleteBatchReason").modal("hide");
      if (shoulReset) {
        this.$v.$reset();
      }
    },
    handleExport() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      const batchId = Number(this.$route.params.id);

      this.$http
        .get(process.env.GET_LIST_BATCH_INSURANCE + `/${batchId}/export`, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(response.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Exported-batch-insurance-${this.detailData.label}.xlsx`;
          a.click();
          a.remove();
        })
        .catch((error) => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    // Other Functions
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    openModal(modalName) {
      $("#modal" + modalName).modal("show");
    },
    dateFormat($date) {
      const d = new Date($date);
      if (d.getDate().toString().length == 1) {
        var date = "0" + d.getDate().toString();
      } else {
        date = d.getDate();
      }
      if ((d.getMonth() + 1).toString().length == 1) {
        var month = "0" + (d.getMonth() + 1).toString();
      } else month = d.getMonth() + 1;
      return date + "-" + month + "-" + d.getFullYear();
    },
    toDataPage(pagePost) {
      this.$router.push({
        path: `/insurance/batch/${this.$route.params.id}`,
        query: {
          page: pagePost,
          itemPerPage: this.$route.query.itemPerPage,
        },
      });
      location.reload();
      // this.getDetailBatchInsurance(this.$route.params.id);
    },
    searchData() {
      this.$router.push({
        path: `/insurance/batch/${this.$route.params.id}`,
        query: {
          page: 1,
          itemPerPage: this.itemPerPage,
        },
      });
      // location.reload();
      // this.getDetailBatchInsurance(this.$route.params.id);
    },
  },
  created() {
    const allPermission = JSON.parse(localStorage.getItem("roles"));
    this.cancelInsurancePermission =
      allPermission && allPermission.indexOf("15.2") >= 0;
    this.selectInsurance = localStorage.getItem("selectInsurance")
      ? JSON.parse(localStorage.getItem("selectInsurance"))
      : [];
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.getDetailBatchInsurance(this.$route.params.id);
    this.getAllCompletingDataFile();
  },
  watch: {
    insuranceRate: function (a) {
      if (a.length > 1 && a[0] == "0" && a[1] != ".") {
        this.insuranceRate = a.slice(1);
      }
    },
    selectInsurance: function (a) {
      this.disableSave = false;
      localStorage.setItem("selectInsurance", JSON.stringify(a));
      for (var i = 0; i < a.length; i++) {
        if (a[i].year == null || a[i].sumInsured == "0") {
          this.disableSave = true;
        }
      }
    },
  },
  // computed: {
  //   reversedMessage: function () {
  //     localStorage.setItem('selectInsurance', this.selectInsurance)
  //     return ''
  //   }
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.detail-patch-container >>> .multiselect__tags {
  border-radius: 8px !important;
}

input[type="date"] {
  height: 42px;
  border-color: #e8e8e8;
  border-radius: 8px;
}

/* input[type="date"] {
  -webkit-appearance: none; Safari and Chrome 
  -moz-appearance: textfield;  Firefox
  appearance: none;
  position: relative;
  z-index: 1;
} */

/* Hide the calendar icon in certain browsers */
/* input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
} */

.total-data {
  margin-top: 7px;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797fb;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797fb;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797fb;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.border-red {
  border-color: red;
}

.one-line .ol-label.storage {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}

.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.input-group-addon {
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  margin: 0px 0px 0px 0px;
  height: fit-content;
}

.label-addon-rp {
  margin: 5px 0px;
}

.modal-lg,
.modal-xl {
  max-width: 1200px;
}

td,
tr {
  text-align: center;
}

.btn-action {
  border-radius: 0.6rem;
}

.btn-action-download {
  border-color: rgba(151, 203, 251, 0.5);
}
.btn-action-trash {
  border-color: rgba(255, 52, 68, 0.5);
}

.btn-action-download:hover {
  background-color: rgba(151, 203, 251, 1);
}
.btn-action-trash:hover {
  background-color: rgba(255, 52, 68, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/DetailBatchInsurance.vue